module.exports = __webpack_public_path__ + "headshot-danny-sullivan.98e8e3.png";